module.exports = __webpack_public_path__ + "static/media/Linux-Shell.01e5f554.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Linux-Shell.png
// module id = 482
// module chunks = 0